import {Button, Flex, Spin} from "antd";
import {useLocation, useNavigate} from "react-router";
import React, {useEffect, useState} from "react";
import {getRequestWithParams} from "../../../../api/httpRequest";
import Step2 from "../Step2";
import "./EditConcourseGroups.less"
import {concourseGroupsStore, IConcourseGroup, resultStore} from "../../../../store/admissions/admissionStore";
import {IEditConcourseGroups, IEditConcourseGroupsResponse} from "../../model/admissionModel";
import Typography from "antd/lib/typography";
import {filterStore} from "../../../../store/admissions/stepperStore";
import {IoIosCloseCircle} from "react-icons/io";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";


export default function EditConcourseGroups() {

    const location = useLocation();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const {result, setResult} = resultStore()
    const {filter, setFilter} = filterStore();
    const [sending, setSending] = useState(false);
    const {concourseGroups, setConcourseGroups} = concourseGroupsStore();
    const navigate = useNavigate()
    const {xl} = useBreakpoint()
    const [statement, setStatement] = useState<IEditConcourseGroupsResponse>({
        UID: "",
        training: []
    })

    useEffect(() => {

        getRequestWithParams(`/server/proxy/contracts/GetApplication`, {docID: location.state.statement})
            .then((res) => {
                setStatement(res.data);
                setResult({
                    ...result,
                    selectedConcourceGroupsCodes: res.data?.training.map((item: IEditConcourseGroups) => item.CompetitionGroupCode),
                    selectedSpecQualifier: res.data?.training.map((item: IEditConcourseGroups) => item.specQualifier)
                })
                setFilter({
                    ...filter,
                    basistraining: res.data.training[0].basistraining,
                    kindsLevelFormation: res.data.training[0].kindsLevelFormationvalue,
                })
                setIsLoading(false)
            })
    }, []);

    const SelectedConcourseGroups = (props: { group: IConcourseGroup, key: number }) => {
        return (
            <Flex className={"admission-edit-selected-group"} vertical={true} justify={"center"} align={"center"}
                  key={props.key}>
                <Flex style={{padding: "8px 16px", backgroundColor: "whitesmoke", width: "100%"}}
                      justify={"space-between"} align={"center"}>
                    <Typography.Text
                        strong>{props.group.specQualifier} {props.group.specName}</Typography.Text>
                    <Flex align={"center"} justify={"center"}>
                        <Button type={"text"} icon={<IoIosCloseCircle size={24} style={{color: "gray"}}/>}
                                onClick={() => {
                                    let newGroups = result.selectedConcourceGroupsCodes;

                                    const groupIndex = newGroups.indexOf(props.group.concourseGroupsCode, 0);
                                    if (groupIndex > -1) {
                                        newGroups.splice(groupIndex, 1);
                                    }

                                    let newSpecs = result.selectedSpecQualifier;

                                    const specIndex = newSpecs.indexOf(props.group.specQualifier, 0);
                                    if (specIndex > -1) {
                                        newSpecs.splice(specIndex, 1);
                                    }

                                    setStatement({
                                        ...statement,
                                        training: [
                                            ...statement.training.filter((item: IEditConcourseGroups) => item.CompetitionGroupCode !== props.group.concourseGroupsCode)
                                        ]
                                    })

                                    setResult({
                                        ...result,
                                        selectedConcourceGroupsCodes: newGroups,
                                        selectedSpecQualifier: newSpecs
                                    })
                                }}/>
                    </Flex>
                </Flex>
                <Flex style={{width: '100%', padding: "8px 16px"}} vertical={true}>
                    <Typography.Text>{`Уровень образования: ${props.group.kindsLevelFormation.display};`}</Typography.Text>
                    <Typography.Text>{`Форма обучения: ${props.group.kindsLevelFormation.display};`}</Typography.Text>
                    <Typography.Text>{`Основа обучения: ${props.group.basistraining};`}</Typography.Text>
                </Flex>
            </Flex>
        )
    }

    const getSelectedConcourseGroups = () => {
        return concourseGroups.filter((item: IConcourseGroup) => result.selectedConcourceGroupsCodes.includes(item.concourseGroupsCode))
    }

    return (
        <Flex className={"admission-edit-page"} style={{flexDirection: !xl ? 'column-reverse' : "row"}} align="center"
              justify="center" gap={16} vertical={!xl}>
            {!isLoading ?
                <>
                    <Flex className={"admission-edit-groups"} style={{width: !xl ? "100%" : "80%"}} align="center"
                          justify="center" vertical={true} gap={16}>
                        <Step2 title={"Редактирование конкурсных групп"} edit={true}/>
                        <Button loading={sending} type={"primary"} onClick={() => {
                            navigate("/admission/edit/priority", {state: {statement: location.state.statement}})
                        }}>Перейти к редактированию приоритетов</Button>
                    </Flex>
                    <Flex className={xl ? "admission-edit-selected" : "admission-edit-selected-mobile"}
                          vertical={true}>
                        <Flex style={{width: "100%", padding: "16px"}} justify="center" align="center" vertical={true}>
                            <Typography.Text style={{fontSize: "18px"}}>Выбранные конкурсные группы</Typography.Text>
                        </Flex>
                        <Flex vertical={true} gap={16} style={{overflowY: "auto", height: "80%"}}>
                            {getSelectedConcourseGroups().map((item: IConcourseGroup, index: number) => {
                                return (
                                    <SelectedConcourseGroups group={item} key={index}/>
                                )
                            })}
                        </Flex>
                    </Flex>
                </>
                :
                <Flex style={{width: "100%", height: "100%", backgroundColor: "white"}} align="center" justify="center">
                    <Spin/>
                </Flex>
            }
        </Flex>
    )
}
